export const HOME = "/";
export const ABOUT_ME = "/about_me";
export const RECENT_POSTS = "/recent_posts";
